import { Row, Col } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const PathMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="identifier" />
      </Col>
    </Row>
  );
};
